import { AnswerPathTreeNode } from '@zinnia/form-engine-sdk';

import { NodeIds } from '../../nodeIds';

export const insuredConfirmName: AnswerPathTreeNode = { path: 'confirmName', nodeId: NodeIds.insuredConfirmName };
